"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_hook_form_1 = require("react-hook-form");
var app_1 = require("../app");
var error_message_1 = __importDefault(require("../components/error-message"));
var styling_1 = require("./styling");
var RadioOption = function (_a) {
    var title = _a.title, description = _a.description, value = _a.value, name = _a.name, register = _a.register;
    // matching the htmlFor of the label to the id of the input makes clicking the entire label trigger selection of the input
    var id = "".concat(name, "-").concat(value);
    return (react_1.default.createElement("label", { htmlFor: id, className: 'width-100 flex-container align-middle padding-horizontal-4 padding-vertical-2 cursor-pointer', style: { borderWidth: 1, borderRadius: 10, borderStyle: 'solid' } },
        react_1.default.createElement("input", { id: id, name: name, type: 'radio', value: value, ref: register({ required: { value: true, message: 'Required' } }), style: { height: 20, width: 20 } }),
        react_1.default.createElement("div", { className: 'w-2' }),
        react_1.default.createElement("div", { className: 'flex-container flex-dir-column align-center' },
            react_1.default.createElement("div", { className: 'font-semibold' }, title),
            react_1.default.createElement("div", null, description))));
};
var PottyTraining = function (_a) {
    var NavBar = _a.NavBar, initialStepFormData = _a.initialStepFormData, setStepFormData = _a.setStepFormData;
    var _b = (0, react_hook_form_1.useForm)({ defaultValues: initialStepFormData, mode: 'onChange' }), register = _b.register, handleSubmit = _b.handleSubmit, errors = _b.errors, formState = _b.formState;
    var onSubmit = function (data) { return setStepFormData(data); };
    var beforeGoNext = function () { return __awaiter(void 0, void 0, void 0, function () {
        var canGoNext, onError;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    canGoNext = true;
                    onError = function () {
                        canGoNext = false;
                    };
                    return [4 /*yield*/, handleSubmit(onSubmit, onError)()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, canGoNext];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'h-8' }),
        react_1.default.createElement("div", null,
            react_1.default.createElement("form", { className: styling_1.formClassName },
                react_1.default.createElement("div", { className: styling_1.fieldContainerClassName, style: styling_1.fieldContainerStyle },
                    react_1.default.createElement("div", { className: styling_1.fieldHeadingClassName }, "Are you Potty Training?"),
                    react_1.default.createElement("div", { className: 'space-y-4' },
                        react_1.default.createElement(RadioOption, { name: 'pottyTraining', value: app_1.POTTY_TRAINING_OPTION.NOT_YET, title: 'Nope.', description: 'Got it. You\u2019re deep in doody land so our diaper bundle is best for you.', register: register }),
                        react_1.default.createElement(RadioOption, { name: 'pottyTraining', value: app_1.POTTY_TRAINING_OPTION.JUST_STARTING, title: 'I just started.', description: 'With tricky tinkle-poopy times ahead, you need our diaper & training pants bundle.', register: register }),
                        react_1.default.createElement(RadioOption, { name: 'pottyTraining', value: app_1.POTTY_TRAINING_OPTION.YES, title: 'Yes!', description: 'Yay! Our training pants bundle will help get your wee-one wee-ing in the potty!', register: register })),
                    react_1.default.createElement("div", { className: 'h-2' }),
                    react_1.default.createElement(error_message_1.default, { error: errors.pottyTraining })))),
        react_1.default.createElement(NavBar, { backButtonEnabled: true, nextButtonEnabled: formState.isValid, beforeGoNext: beforeGoNext })));
};
exports.default = PottyTraining;
